import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

export function getMsalInstance(
  msalConfig,
  navigateToLoginRequestUrl?: boolean,
): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: msalConfig.frontendClientId,
      authority: msalConfig.authority,
      redirectUri: msalConfig.redirectUri,
      navigateToLoginRequestUrl: navigateToLoginRequestUrl ?? false,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      allowRedirectInIframe: !!msalConfig.allowRedirectInIframe,
    },
  });
}

export function getMsalGuardConfig(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

export function getMsalInterceptorConfig(
  msalConfig,
  resource?: string,
  extraEndpoints?: { url: string; clientId: string }[],
  unprotectedEndpoints?: string[],
): MsalInterceptorConfiguration {
  let endpoint = msalConfig.apiResource;
  if (resource) {
    endpoint += resource;
  }

  const resourceMap = new Map();

  if (unprotectedEndpoints) {
    for (const unprotectedEndpoint of unprotectedEndpoints) {
      // eslint-disable-next-line unicorn/no-null
      resourceMap.set(unprotectedEndpoint, null);
    }
  }

  resourceMap.set(endpoint, [`api://${msalConfig.backendClientId}/all`]);

  if (extraEndpoints) {
    for (const extraEndpoint of extraEndpoints) {
      resourceMap.set(extraEndpoint.url, [
        `api://${extraEndpoint.clientId}/all`,
      ]);
    }
  }

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: resourceMap,
  };
}
